import React from 'react'
import {Spinner as BsSpinner} from 'react-bootstrap'

import './styles.css'

const Spinner = () => (
  <BsSpinner animation="grow" className="spinner-loga"/>
)

export default Spinner